'use strict';
// write your code here
var populations = document.querySelectorAll('.population');
var averageElement = document.querySelector('.average-population');
var totalElement = document.querySelector('.total-population');
var populationValues = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = populations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var population = _step.value;
        var value = Number(population.textContent.replace(/,/g, ''), 10);
        populationValues.push(value);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var totalPopulation = populationValues.reduce(function(acc, curr) {
    return acc + curr;
}, 0);
var averagePopulation = Math.round(totalPopulation / populationValues.length);
averageElement.textContent = averagePopulation.toLocaleString('en-US');
totalElement.textContent = totalPopulation.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.6b2c3288.js.map
